<template>
  <div
    v-if="isBuyingExtraGuaranteeOnly"
    class="w-full"
  >
    <p class="font-bold mb-3 mt-3 w-full">
      {{ $t('extra-guarantee.description') }}
    </p>
    <div class="flex gap-4 w-full">
      <ProductCardVerticalImage
        :link="''"
        :image="parentProductImage"
        :title="parentProductName"
      />
      <div class="flex-grow flex flex-col justify-between gap-2">
        <div class="flex flex-col gap-2">
          <ProductCardVerticalTitle
            :link="''"
            :title="parentProductName"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { productGetters } from '~/utils/ct';

import { EXTRA_GUARANTEE } from '~~/constants/productType';
import type { LineItemWithGuaranteeInside } from '~~/types/product/LineItemExtended';

export default defineComponent({
  name: 'GuaranteeParentProductCardVertical',

  props: {
    product: {
      type: Object as PropType<LineItemWithGuaranteeInside>,
      required: true,
    },
  },
  setup(props) {

    const {
      search: searchProduct,
      masterProduct: buyingExtraGuaranteeParentProduct,
    } = useProductExtended(props.product?.parentSku || 'guarantee-parent-product');

    if (props.product?.parentSku) {

      searchProduct({ skus: [props.product?.parentSku] }, { includeUnsellableProducts: true });
    
    }

    const isBuyingExtraGuaranteeOnly: ComputedRef<boolean> = computed(
      () => {

        return props.product?.productType?.key === EXTRA_GUARANTEE &&
         buyingExtraGuaranteeParentProduct.value !== null;
      
      });

    const parentProductName = computed(() => {

      return productGetters.getName(buyingExtraGuaranteeParentProduct.value);
    
    });

    const parentProductImage = computed(() => {

      return productGetters.getGallery(buyingExtraGuaranteeParentProduct.value)?.[0]?.small || '';
    
    });

    return {
      buyingExtraGuaranteeParentProduct,
      isBuyingExtraGuaranteeOnly,
      parentProductName,
      parentProductImage,
    };
  
  },
});

</script>
